import { render, staticRenderFns } from "./ResizeColDouble.vue?vue&type=template&id=3fbc955e&scoped=true"
import script from "./ResizeColDouble.vue?vue&type=script&lang=js"
export * from "./ResizeColDouble.vue?vue&type=script&lang=js"
import style0 from "./ResizeColDouble.vue?vue&type=style&index=0&id=3fbc955e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc955e",
  null
  
)

export default component.exports